import { styled } from '@nykaa/ui-components';

//styled component
export const StyledIcon = styled.div<{ opacity: string; size: number; marginRight: number }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  margin: 0;
  margin-right: ${({ marginRight }) => `${marginRight}px`};
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.textOutline};

  &.small {
    transform: scale(0.6);
  }
  &.active {
    transform: scale(1.3);
    transform-origin: center;
    background-color: ${({ theme }) => theme.colors.textPrimary};
  }

  &:not(:last-of-type) {
    margin-right: ${({ marginRight }) => `${marginRight}px`};
  }
`;

export const StyledSVG = styled.svg<{ size: number; marginRight: number }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  margin: auto 0;
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  svg path {
    fill: ${({ theme }) => theme.colors.textOutline};
  }
  &.small {
    transform: scale(0.6);
  }
  &.active {
    transform: scale(1.3);
    transform-origin: center;
    margin-right: ${({ marginRight }) => `${marginRight}px`};

    svg path {
      fill: ${({ theme }) => theme.colors.textPrimary};
    }
  }
`;
